import MenuIcon from "@mui/icons-material/Menu";
import PersonIcon from "@mui/icons-material/Person";
import {
  Box,
  Button,
  Drawer,
  IconButton,
  MenuItem,
  Typography,
} from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../customHooks/useAuth";

const menuItems = [
  { label: "Overview", value: "/overview" },
  {
    label: "Accounts",
    value: "/accounts",
  },
  { label: "Cloner", value: "/cloner" },
  { label: "Usage Analytics", value: "/analytics" },
];

export default function Menu() {
  const [openDrawer, setOpenDrawer] = useState(false);
  const toggleDrawer = useCallback(() => {
    setOpenDrawer((prev) => !prev);
  }, []);
  const navigate = useNavigate();

  const navigationHandler = useCallback(
    (path: string) => {
      navigate(path);
    },
    [navigate]
  );
  const auth = useAuth();
  const logoutButton = useMemo(
    () => (
      <Button onClick={() => auth.logOut!()} size="small">
        Logout
      </Button>
    ),
    [auth]
  );
  return (
    <Box
      display={"flex"}
      width={"100%"}
      alignItems={"center"}
      justifyContent={"space-between"}
    >
      <Box display={"flex"} gap={1} alignItems={"center"}>
        <img
          draggable={false}
          width={30}
          height={"auto"}
          src="img/trendrating_crm_icon.png"
          alt="trendrating logo"
        />
        {menuItems.map((item, index) => (
          <MenuItem sx={{cursor:"pointer"}} onClick={() => navigationHandler(item.value)} key={index}>
            {item.label}
          </MenuItem>
        ))}
      </Box>
      <Box sx={{ display: { xs: "none", md: "flex" } }} gap={1}>
        <Box display={"flex"} alignItems={"center"}>
          <IconButton color="secondary" size="small">
            <PersonIcon />
          </IconButton>
          <Typography>
            {auth.user.firstName} {auth.user.lastName}
          </Typography>
        </Box>
        {logoutButton}
      </Box>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <IconButton onClick={toggleDrawer} size="large">
          <MenuIcon fontSize="large" />
        </IconButton>

        <Drawer anchor="right" open={openDrawer} onClose={toggleDrawer}>
          <Box display={"flex"} flexDirection={"column"} gap={2}>
            {menuItems.map((item, index) => (
              <MenuItem
                onClick={() => navigationHandler(item.value)}
                key={index}
              >
                {item.label}
              </MenuItem>
            ))}
            {logoutButton}
          </Box>
        </Drawer>
      </Box>
    </Box>
  );
}
